import {View} from "./View"
export const SubscriptionEmailLink=  () => {
    return(
        <View />
    )
}
